import {
  createStackHeaderNavigator,
  ModalCloseButton,
} from "@towersystems/roam-common-native";
import {
  GiftCardPaymentRootParamList,
  PaymentRootScreenParamList,
} from "../../../../types";
import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import { GiftCardPaymentScreen } from "./GiftCardPaymentScreen";
import { SearchGiftCardScreen } from "./SearchGiftCardScreen";
import { GiftCardDetailsScreen } from "./GiftCardDetailsScreen";
import { useCheckoutContextProvider } from "../../utils/checkout";
import { moneyToFormattedString } from "@towersystems/roam-common/lib/shared-utils";

const Stack = createStackHeaderNavigator<GiftCardPaymentRootParamList>();

export interface GiftCardPaymentRootScreenProps
  extends StackScreenProps<
    PaymentRootScreenParamList,
    "GiftCardPaymentRootScreen"
  > {}

export const GiftCardPaymentRootScreen = () => {
  const { balance } = useCheckoutContextProvider();

  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: true,
        title: `Sale Balance: ${moneyToFormattedString(balance)}`,
        headerLeft: () => <ModalCloseButton type="Back" />,
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
      }}
    >
      <Stack.Screen
        name="SearchGiftCardScreen"
        component={SearchGiftCardScreen}
      />
      <Stack.Screen
        name="GiftCardDetailsScreen"
        component={GiftCardDetailsScreen}
      />
      <Stack.Screen
        name="GiftCardPaymentScreen"
        component={GiftCardPaymentScreen}
      />
    </Stack.Navigator>
  );
};
